import React, {Component} from "react";
import {
  Collapse,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  Navbar,
  NavbarToggler,
  NavItem
} from "reactstrap";
import {Avatar} from "antd";

import AEPNavbarBrand from "./aep-navbar-brand";
import NotificationDropdown from "./notification-dropdown";

import "bootstrap/dist/css/bootstrap.css";
import "./header-nav.css";
import { UserOutlined } from '@ant-design/icons';

class MobileNavigation extends Component {
  constructor(props) {
    super(props);

    this.toggleDropdown = this.toggleDropdown.bind(this);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      navbarCollapsed: false,
      dropdownOpen: false,
    };
  }

  toggleNavbar() {
    this.setState({
      navbarCollapsed: !this.state.navbarCollapsed
    });
  }

  toggleDropdown() {
    this.setState(previousState => ({
      dropdownOpen: !previousState.dropdownOpen
    }));
  }

  render() {
    return (
      <Navbar color="white" light className="pt-1 pl-2 ml-0">
        <AEPNavbarBrand />
        <NavbarToggler onClick={this.toggleNavbar} />
        <Collapse isOpen={this.state.navbarCollapsed} navbar>
          <Nav className="ml-auto" id="responsive-menu" navbar>
            <NavItem className="my-2">
              <NotificationDropdown {...this.props} />
            </NavItem>
            <NavItem className="my-2">
              <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropdown} style={{ boxShadow: "none" }} inNavbar>
                <DropdownToggle color="white">
                  <Avatar size="small" icon={<UserOutlined />}/>
                </DropdownToggle>
                <DropdownMenu right style={{ width: "100px", height: "50px", overflow: "scroll", borderColor: "#0ca0da"}}>
                  <DropdownItem href={window.location.origin + "/logout"}>Log out</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    );
  }
}

export default MobileNavigation;
